import axiosInstance from 'api/axiosInstance';

export interface FileInfo {
  FileID?: number;
  Name: string;
  ContentType: string;
  Size?: number;
  [key: string]: any;
}

/**
 * Get file info for VV (Virtual Vault) files
 */
export const getVVFileInfo = async (fileId: string | number): Promise<FileInfo | null> => {
  try {
    const response = await axiosInstance.get(
      `/api/fileuploadservice/GetFileInfo?FileId=${fileId}`,
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching VV file info:', error);
    return null;
  }
};

/**
 * Get file info for DDS files
 */
export const getDDSFileInfo = async (fileId: string | number): Promise<FileInfo | null> => {
  try {
    const response = await axiosInstance.get(
      `/api2.0/CANDDS/GetDDSFileObject/${fileId}`,
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching DDS file info:', error);
    return null;
  }
};

/**
 * Get file info based on file type
 */
export const getFileInfo = async (
  fileId: string | number,
  fileType: 'vv' | 'dds' = 'vv'
): Promise<FileInfo | null> => {
  if (fileType === 'dds') {
    return getDDSFileInfo(fileId);
  }
  return getVVFileInfo(fileId);
};

export default getFileInfo;
